<template>
    <div>
        <strong v-if="title && identify" class="text-center d-block pb-4">{{ title }}</strong>
        <div class="d-flex justify-content-around align-items-center">
            <a v-if="identify" :href="viberLink" target="_blank" class="mx-2">
                <i class="fab fa-viber fa-3x" :class="{ 'fa-4x' : iconsLg}" style="color: #7D4D9D; cursor: pointer;"></i>
            </a>
            <a v-if="identify" :href="telegramLink" target="_blank" class="mx-2 text-center">
                <i class="fab fa-telegram fa-3x" :class="{ 'fa-4x' : iconsLg}" style="color: #6CBBF8; cursor: pointer;"></i>
            </a>
<!--            <a v-if="identify" :href="facebookLink" target="_blank" class="mx-2 text-right">-->
<!--                <i class="fab fa-facebook fa-3x" :class="{ 'fa-4x' : iconsLg}" style="color: #39579B; cursor: pointer;"></i>-->
<!--            </a>-->
        </div>
    </div>
</template>

<script>

export default {
    name: "Messengers",
    props: ["device", "iconsLg", "title"],
    computed: {
        viberLink() {
            return "viber://pa?chatURI=smartmisto&context=" + this.identify;
        },
        telegramLink() {
            return "https://t.me/smartmisto_bot?start=" + this.identify;
        },
        facebookLink() {
            return "https://m.me/625945008039045?ref=" + this.identify;
        },
        identify() {
            return this.device?.identify;
        }
    },
}
</script>

<style scoped>

</style>